(function ($) {
  Drupal.behaviors.tabbedToutV1 = {
    attach: function (context) {
      $('.js-tabbed-tout--v1', context).each(function () {
        var $module = $(this);
        var $titles = $('.js-tout-content-title', $module); // Used to create our buttons for desktop
        var $desktopMenu = $('.js-tout-content-list', $module);
        var $slick = $('.js-slick', $module);
        // Get the colors for the touts from the mustache template.
        // We're doing this to avoid issues with placing generic style tags inside of the mustache file
        //
        var activeStyle = {
          background: $module.data('active-background'),
          color: $module.data('active-text')
        };
        var defaultStyle = {
          'border-color': $module.data('border-color'),
          color: $module.data('text-color')
        };

        $slick.slick({
          infinite: false,
          dots: true,
          mobileFirst: true,
          draggable: true,
          arrows: false,
          waitForAnimate: false,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                unslick: true,
                dots: false,
                draggable: false,
                fade: false
              }
            }
          ]
        });

        // Desktop only interaction
        $titles.each(function () {
          var title = $(this).text();

          $desktopMenu.append('<a href="#" class="js-tout-content-trigger" role="tab">' + title + '</a>');
        });

        // Do our slide changing
        var $contentTriggers = $('.js-tout-content-trigger', $module);

        $contentTriggers.on('click', function (event) {
          event.preventDefault();
          var index = $(this).index();

          $contentTriggers.not(this).removeClass('active');
          $(this).addClass('active');
          // If these styles are set in the template, apply our change
          // 1. Apply active styles to new tab
          // 2. Remove all styles from previous active tab and apply default styles
          if (activeStyle.background || activeStyle.color) {
            $(this).css(activeStyle);
            // If we have an active style set, make sure that it isnt lingering anywhere when we switch active tabs
            $contentTriggers.not(this).attr('style', '');
          }
          // Apply the default CSS styling if it exists
          if (defaultStyle['border-color'] || defaultStyle.color) {
            $contentTriggers.not(this).css(defaultStyle);
          }

          $slick.slick('slickGoTo', index);
        });

        // Code for Tabbed Content
        $('.js-tabbed_tout_content').each(function () {
          var $lastTabbableElement = $(this).find('a, input, button, select, [tabindex]:not([tabindex="-1"])').last();

          $lastTabbableElement.on('focusout', function () {
            $contentTriggers.removeAttr('tabindex');
            $('.js-tout-content-trigger.active').next().focus();
          });
        });

        $contentTriggers.on('keydown', function (e) {
          switch (site.getKeycode(e)) {
            case 13:
              $contentTriggers.attr('tabindex', '-1').removeClass('active');
              $(this).trigger('click');
              break;
            case 39:
              $(this).next().focus();
              break;
            case 37:
              $(this).prev().focus();
              break;
            case 9:
              var index = $(this).index();
              var $tabbedWrapper = $(".js-tabbed_tout_content[data-slick-index='" + index + "']");
              var $childCount = $tabbedWrapper.find('a, input, button, select, [tabindex]:not([tabindex="-1"])').length;

              if ($childCount > 0 && $(this).hasClass('active')) {
                $contentTriggers.attr('tabindex', '-1');
                $(this).attr('tabindex', '0');
              } else {
                $(this).focus();
              }
              break;
          }
        });

        $contentTriggers.css(defaultStyle);

        // Start with first one clicked
        $contentTriggers.eq(0).trigger('click');

        $('img', $module).on('load', function () {
          $slick.resize();
        });

        $(window).on('resize.toutTabbedBlock', _.debounce(function () {
          $slick.resize();
        }, 150));
      });
    }
  };
})(jQuery);
